import { FormattedMessage } from 'react-intl'
import { Box, Button, Typography } from '@mui/material'
import { ICustomPrice } from '../../interface'
import { useContext } from 'react'
import { ProductContext } from './EducationLayout'
import EducationMetadataBlock from './EducationMetadataBlock'
import { IntlLink } from '../Common/IntlComponents'

interface ICustomAccordionContent {
  data: ICustomPrice
}

const CustomAccordionContent = ({ data }: ICustomAccordionContent) => {
  const product = useContext(ProductContext)
  const { descriptions, href, buttonName, price, title } = data
  const isSubscription = href.includes('membership')

  return (
    <Box data-gtm-click-subsection1={title}>
      {descriptions.map((description, index) => (
        <Typography key={index}>
          <FormattedMessage id={description} values={{ product }} />
        </Typography>
      ))}
      {!!price && (
        <Box sx={{ my: 2 }}>
          <EducationMetadataBlock title='education.metadata.price' data={price} isSubscription={isSubscription} />
        </Box>
      )}
      <Button
        data-gtm-click-subsection2='primary-cta'
        component={IntlLink}
        to={href}
        variant='contained'
        sx={{ mt: 2 }}
      >
        <FormattedMessage id={buttonName} />
      </Button>
    </Box>
  )
}

export default CustomAccordionContent
